


























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import Table from '@shared/components/tables/table.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import { AccountingReportSale } from '@accounting/interfaces/accounting-reports';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';
import {
  accountingReportDisplayFields,
  accountingReportSaleTableFields,
  filters,
} from '@/config/accounting_reports';
import TableFooterPagination from '@shared/layouts/wrappers/table/table-footer-pagination.vue';
import PaginationInterface from '@core/interfaces/pagination-interface';
import OrderingInterface from '@core/interfaces/ordering-interface';
import { DateRangeInterface, SelectOptionInterface } from '@shared/interfaces/inputs';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import DateRange from '@shared/components/forms/inputs/date-range/date-range.vue';

@Component({
  name: 'bc-accounting-report-sale-table',
  components: {
    'bc-search-input': SearchInput,
    'bc-table-wrapper': TableWrapper,
    'bc-multi-select': MultiSelect,
    'bc-date-range': DateRange,
    'bc-table': Table,
    'bc-table-footer-pagination': TableFooterPagination,
    'bc-display-field-badge': DisplayFieldBadge,
    'bc-display-contact-link': DisplayContactLink,
    'bc-display-code': DisplayFieldCode,
  },
})
export default class AccountingReportSaleTable extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: true }) readonly hideCheckColumn: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: true }) readonly showSearchFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPeriodFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOriginFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showProductTypeFilter: boolean;

  // DATA
  // Table items & options
  loading: boolean = false;
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  ordering: OrderingInterface = {
    order_by: 'date',
    order_direction: 'asc',
  };
  orderByOptions: SelectOptionInterface[] = [
    {
      text: this.$t('global.accounting_reports.ordering.code.label').toString(),
      value: 'code',
    },
    {
      text: this.$t('global.accounting_reports.ordering.date.label').toString(),
      value: 'date',
    },
  ];
  items: AccountingReportSale[] = [];

  // Filters
  submittedSearch: string = null;
  selectedPeriod: string = null;
  selectedOrigin: string[] = [];
  selectedProductType: string[] = [];
  selectedDateRange: DateRangeInterface = {
    start_date: null,
    end_date: null,
  };

  // COMPUTED
  // COMPUTED PROPERTIES
  get showDateRangeFilter(): boolean {
    return this.selectedPeriod === 'custom';
  }

  get selectedStartDate(): string {
    return this.selectedDateRange.start_date;
  }

  get selectedEndDate(): string {
    return this.selectedDateRange.end_date;
  }
  get searchFilterPlaceholder(): string {
    return this.$t('global.table.filter.search').toString();
  }

  get periodFilterPlaceholder(): string {
    return this.$t(`${filters?.period?.placeholder}`).toString();
  }

  get originFilterPlaceholder(): string {
    return this.$t(`${filters?.origin?.placeholder}`).toString();
  }

  get productTypeFilterPlaceholder(): string {
    return this.$t(`${filters?.productType?.placeholder}`).toString();
  }
  // Filters options
  get periodFilterOptions(): SelectOptionInterface[] {
    return filters?.period?.options || [];
  }

  get originFilterOptions(): SelectOptionInterface[] {
    return filters?.origin?.options || [];
  }

  get productTypeFilterOptions(): SelectOptionInterface[] {
    return filters?.productType?.options || [];
  }
  get tableFields(): BPCTableField[] {
    return accountingReportSaleTableFields || [];
  }
  get displayConfig() {
    return accountingReportDisplayFields;
  }
  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
    ].join('--');
  }

  // METHODS
  clickOnReload(): void {
    console.log('reload list');
  }
  clickOnChangeOrderDirection(direction): void {
    this.ordering.order_direction = direction;
  }

  getQueryParams() {
    return {
      orderBy: this.ordering.order_by,
      orderDirection: this.ordering.order_direction,
      perPage: this.pagination.per_page,
      page: this.pagination.current_page,
    };
  }

  async getItems() {
    this.loading = true;
    const params = this.getQueryParams();
    const baseUrl = this.$bpcApiRouteHelper.getEntityPath('accounting-report');
    const result = await this.$bpcApi.get(`${baseUrl}/sales`, { params: params }).toPromise();
    console.log('RESULT', result);
    this.items = result.data;
    this.loading = false;
    this.pagination = result.meta;
    // this.setUrlParams(params);
  }

  getItemsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getItems();
      }
    }, 300);
  }

  // LIFECYCLE
  mounted() {
    this.getItemsIfStopChanging();
  }
}
